// externals
import React from 'react';
import { useSelector } from 'react-redux';

// components
import { Alert } from '@interstate/components/Alert';
import { Box } from '@interstate/components/Box';

// libraries
import * as firstPencilSelectors from '@makemydeal/dr-dash-store/selectors/firstPencilSelectors';
import { SALES_CHECK_IN_APPLICATION_NAME } from '@makemydeal/dr-shared-types';

export const FIRST_PENCIL_SCI_REQUEST_TITLE = `Updates from ${SALES_CHECK_IN_APPLICATION_NAME}`;

export const FIRST_PENCIL_SCI_REQUEST_TEST_ID = 'first-pencil-sci-request';

export type FirstPencilScreen = 'create-deal' | 'programs-incentives' | 'change-vehicle';

export type FirstPencilSciRequestAlertProps = {
    screen: FirstPencilScreen;
    marginBottom?: string;
};

export const FirstPencilSciRequestAlert: React.FC<FirstPencilSciRequestAlertProps> = ({ screen, marginBottom }) => {
    const sciRequestComment = useSelector(firstPencilSelectors.getSciRequestComment);

    if (!sciRequestComment) {
        return null;
    }

    return (
        <Box sx={{ marginBottom }}>
            <Alert
                type="caution"
                title={FIRST_PENCIL_SCI_REQUEST_TITLE}
                data-testid={`${FIRST_PENCIL_SCI_REQUEST_TEST_ID}-${screen}`}
            >
                <span data-testid={`${FIRST_PENCIL_SCI_REQUEST_TEST_ID}-${screen}-message`}>{sciRequestComment}</span>
            </Alert>
        </Box>
    );
};

export default FirstPencilSciRequestAlert;
